import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import {
  awaitFeatureFlagsLoaded,
  isFeatureEnabled,
} from "@/modules/feature-flags/utils/posthog";

export const Route = createFileRoute("/$sessionCode")({
  beforeLoad: async () => {
    await awaitFeatureFlagsLoaded();
    if (!isFeatureEnabled("short-url", true)) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: SessionCodeLayout,
});

function SessionCodeLayout() {
  return <Outlet />;
}
